import Popup from "components/shared/popup";
import Dropdown from "components/shared/popup/dropdown";
import React, { useCallback, useRef } from "react";

export default function TagsField(props) {
    const inputRef = useRef(null);

    const PopupComponent = useCallback(
        (popupProps) => {
            return (
                <Dropdown {...popupProps}>
                    <Dropdown.List>
                        {props.documentTags.map((group, i) => (
                            <Dropdown.Item key={i}>
                                {group.text}
                                <Dropdown.List>
                                    {group.items.map((item) => (
                                        <Dropdown.Item key={item.id} onClick={() => handleInsertTag(`{${item.id}}`)}>
                                            {item.text}
                                        </Dropdown.Item>
                                    ))}
                                </Dropdown.List>
                            </Dropdown.Item>
                        ))}
                    </Dropdown.List>
                </Dropdown>
            );
        },
        [props.value],
    );

    const handleInsertTag = (textToInsert) => {
        const input = inputRef.current;
        if (!input) {
            return;
        }

        // Получаем текущую позицию курсора
        const startPos = input.selectionStart;
        const endPos = input.selectionEnd;

        // Вставляем текст в текущую позицию курсора
        const newValue = props.value.substring(0, startPos) + textToInsert + props.value.substring(endPos);
        props.onChange(newValue);

        // Устанавливаем позицию курсора после вставленного текста
        setTimeout(() => {
            input.selectionStart = input.selectionEnd = startPos + textToInsert.length;
            input.focus();
        }, 100);
    };

    return (
        <div className="row form-group field-wrap--value">
            <label className="col-sm-4 col-md-3 col-form-label col-form-label-sm text-md-right text-sm-left field-wrap__label--required">
                Описание
            </label>
            <div className="col-sm-8 col-md-9">
                <div className="input-group mb-3">
                    <input
                        type="text"
                        className="form-control form-control-sm"
                        ref={inputRef}
                        value={props.value}
                        onChange={(e) => props.onChange(e.target.value)}
                    />
                    <div className="input-group-append">
                        <Popup Component={PopupComponent}>
                            <div className="btn btn-sm btn-secondary">&#43; Добавить тег</div>
                        </Popup>
                    </div>
                </div>
            </div>
        </div>
    );
}
